/**
 * Sidekick back-to-top — show only on long pages.
 * Threshold: document taller than ~2.35× the viewport (and at least 1600px).
 */

(function () {
  var MIN_RATIO = 2.35;
  var MIN_PX = 1600;
  var root = document.querySelector('[data-sk-back-to-top]');
  if (!root) return;

  var btn = root.querySelector('[data-sk-btt-btn]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pageIsLong() {
    var h = Math.max(
      document.documentElement.scrollHeight,
      document.body ? document.body.scrollHeight : 0,
    );
    return h >= MIN_PX && h >= window.innerHeight * MIN_RATIO;
  }

  function sync() {
    if (pageIsLong()) {
      root.hidden = false;
      root.setAttribute('data-sk-btt-ready', '1');
    } else {
      root.hidden = true;
      root.removeAttribute('data-sk-btt-ready');
    }
  }

  function goTop() {
    var topEl = document.getElementById('MainContent') || document.body;

    function focusTop() {
      if (!topEl || typeof topEl.focus !== 'function') return;
      if (!topEl.hasAttribute('tabindex')) topEl.setAttribute('tabindex', '-1');
      try {
        topEl.focus({ preventScroll: true });
      } catch (e) {}
    }

    if (reduced.matches) {
      window.scrollTo(0, 0);
      focusTop();
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    focusTop();
  }

  if (btn) btn.addEventListener('click', goTop);

  sync();
  window.addEventListener('load', sync, { once: true });
  window.addEventListener('resize', sync, { passive: true });

  if ('ResizeObserver' in window && document.body) {
    var ro = new ResizeObserver(function () {
      sync();
    });
    ro.observe(document.body);
  }

  /* Late-loading apps (Judge.me, etc.) can stretch the page after first paint. */
  setTimeout(sync, 1200);
  setTimeout(sync, 3200);
})();
